import React, { createContext, useContext, useEffect } from 'react';
import Animated, { useSharedValue, useAnimatedStyle, withRepeat, withTiming, Easing, cancelAnimation, } from 'react-native-reanimated';
import { Modal } from 'native-base';
import { LoadingIcon } from './icons';
export function ADCLoadingSpinner(props) {
    const rotation = useSharedValue(0);
    const animatedStyles = useAnimatedStyle(() => {
        return {
            transform: [
                {
                    rotateZ: `${rotation.value}deg`,
                },
            ],
        };
    }, [rotation.value]);
    useEffect(() => {
        rotation.value = withRepeat(withTiming(360, {
            duration: 800,
            easing: Easing.linear,
        }), -1);
        return () => cancelAnimation(rotation);
    }, [rotation]);
    return (React.createElement(Modal, { ...props, _web: {
            _overlay: {
                style: {
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                }, // position fixed is available on web but not in React Native type
            },
        } },
        React.createElement(Animated.View, { style: [animatedStyles] },
            React.createElement(LoadingIcon, { size: 12 }))));
}
export const ADCLoadingSpinnerContext = createContext(null);
/**
 * Custom hook to open and close a loading spinner at the root of the ThemeProvider. Helpful
 * in cases where having the loading spinner inserted into the DOM hierarchy earlier is needed.
 * @returns An object containg an open and close function.
 */
export function useLoadingSpinner() {
    const context = useContext(ADCLoadingSpinnerContext);
    if (!context) {
        console.warn('ADCLoadingSpinnerContext does not exist.');
        return {
            open: () => { },
            close: () => { },
        };
    }
    return context;
}
